module.exports = "8d77f2bc34a130e560484e730e7698b3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/shrine-top-l-1.png
// module id = 58
// module chunks = 0